<template>
  <div class="riff">
    <Banner :top="0" />
    <div class="riff_bg">
      <div class="riff_icon_box">
        <img
          class="riff_icon"
          src="@/assets/riff/RIFF (1).png"
        >
        <div class="riff_icon1">
          <p>多功能口袋声卡</p>
          <img src="@/assets/riff/Riff_icon.png">
        </div>
      </div>
    </div>
    <div class="goods_msg">
      <div class="msg">
        <img
          class="left"
          src="@/assets/riff/left_text.png"
          alt=""
        >
        <div class="right_text">
          <div class="title">
            <p>官方建议零售价</p>
            <p>699 RMB</p>
          </div>
          <div class="rule">
            四色可选
          </div>
          <div class="round">
            <div />
            <div />
            <div />
            <div />
          </div>
          <div
            class="button"
            @click="clickFun"
          >
            天猫直购
          </div>
        </div>
      </div>
      <div class="icon_box">
        <img
          class="riff_icon"
          src="@/assets/riff/Riff_icon.png"
        >
        <div class="line" />
      </div>
    </div>
    <div class="three">
      <div class="left">
        <div class="left_text">
          <p class="title">
            对标行业高水准<br>品质音色有保障
          </p>
          <p class="content">
            24 bit 96kHz 采样精度<br>
            Codec 音质转换芯片<br>
            高动态余量输入和<br>
            高水平转换器
          </p>
        </div>
      </div>

      <div class="right_img">
        <img src="@/assets/riff/three_img.png">
      </div>
    </div>
    <div class="four">
      <div />
    </div>
    <div class="five">
      <div />
    </div>
    <div class="six">
      <div class="box">
        <img
          src="@/assets/riff/six_icon.png"
          class="img_icon"
        >

        <div class="text">
          <p class="title">
            创新的TONE模式<br>
            仿真3种<br class="br768">
            经典模拟前置放大器
          </p>
          <p class="text_box">
            更加愉悦的声音体验，<br class="br375">更多音色选择<br>
            <span>00 透明</span><br class="br375">
            <span>01 经典</span><br class="br768">
            <span>02 复古</span><br class="br375">
            <span>03 高频提升</span>
          </p>
        </div>
        <img
          src="@/assets/riff/six_icon2.png"
          class="img_icon2"
        >
      </div>
    </div>
    <div class="seven">
      <div class="box">
        <img
          class="seven_bg1"
          src="@/assets/riff/seven_bg1.png"
        >
        <div class="left_text">
          <p>
            连接操控 <br>
            BIAS FX 2
          </p>
          <p>
            全面优化<br>
            使用体验
          </p>
        </div>
        <div class="right_text">
          <p class="rule">
            长按金属旋钮先连接<br>
            左右转动旋钮<br>
            可操控节拍器速度<br>
            音色链开闭或效果器音效快慢<br>
            弹指一挥间
          </p>
          <div class="list">
            <div class="one_line">
              <div>
                <img
                  class="success"
                  src="@/assets/riff/success.png"
                >
                <p>
                  零延迟表现
                </p>
                <span>
                  低至0.03ms，声画更同步
                </span>
              </div>
              <div>
                <img
                  class="success"
                  src="@/assets/riff/success.png"
                >
                <p>
                  干湿比平衡
                </p>
                <span>
                  声音更清晰舒服
                </span>
              </div>
            </div>
            <div class="one_line">
              <div>
                <img
                  class="success"
                  src="@/assets/riff/success.png"
                >
                <p>
                  自动增益
                </p>
                <span>
                  为你适配最佳参数
                </span>
              </div>
              <div>
                <img
                  class="success"
                  src="@/assets/riff/success.png"
                >
                <p>
                  联动操控
                </p>
                <span>
                  可以直接控制BIAS界面
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="eight">
      <div class="box">
        <img
          src="@/assets/riff/eight_icon.png"
          class="icon1"
        >
        <img
          src="@/assets/riff/eight_icon2.png"
          class="icon2"
        >
        <img
          src="@/assets/riff/eight_icon3.png"
          class="icon3"
        >
        <div class="text">
          <p class="text1">
            连接操控<br class="br375"> BIAS FX 2<br>
            丰富音效<br class="br375"> 直接调用
          </p>
          <p class="text2">
            3万种音色元在线音色可下载<br>
            最高可达<br>
            100个箱头<br>
            122个效果器
          </p>
        </div>
        <img
          src="@/assets/riff/eight_icon.png"
          class="icon1_768"
        >
      </div>
    </div>
    <div class="nine1-1" />
    <div class="nine">
      <div class="nine_box">
        <p class="title">
          居家录音更方便
        </p>
        <p class="text">
          不链接BIAS时，也可匹配任何软件进行录音无需额外供电，可当耳放使用
        </p>
      </div>
    </div>
    <div class="ten">
      <div class="ten_box">
        <div class="left">
          <p class="title">
            精致外观设计<br>
            符合人体工学
          </p>
          <p class="rule">
            外观设计兼顾美观与实用<br>
            为了更好的音色创作体验<br>
            从外到内<br>
            我们都全力以赴
          </p>
          <div class="list">
            <div class="one_line">
              <div>
                <img
                  class="success"
                  src="@/assets/riff/success.png"
                >
                <p>
                  铝壳材质
                </p>
                <span>
                  轻巧便携<br>
                  居家外出都能用

                </span>
              </div>
              <div>
                <img
                  class="success"
                  src="@/assets/riff/success.png"
                >
                <p>
                  LCD大屏显示
                </p>
                <span>
                  不用盲猜“听声辩位”<br>
                  看一眼就知道
                </span>
              </div>
            </div>
            <div class="one_line">
              <div>
                <img
                  class="success"
                  src="@/assets/riff/success.png"
                >
                <p>
                  表面角度内倾
                </p>
                <span>
                  表面非完全水平<br>
                  手腕自然倾斜不怕累
                </span>
              </div>
              <div>
                <img
                  class="success"
                  src="@/assets/riff/success.png"
                >
                <p>
                  金属大旋钮
                </p>
                <span>
                  长按，轻点和旋转<br>
                  控制界面，切换不同模式
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <img
            src="@/assets/riff/ten_icon.png"
            class="img"
          >
          <img
            src="@/assets/riff/ten_bg.png"
            class="img2"
          >
        </div>
      </div>
    </div>
    <FooterCommon />
  </div>
</template>
<script>
import Banner from '@/components/banner'
import FooterCommon from '@/components/footer-common'
export default {
  components: {
    Banner,
    FooterCommon
  },

  data () {
    return {}
  },
  methods: {
    clickFun () {
      console.log(123)
      if (this._isMobile()) {
        // alert('手机端')
        window.open('https://m.tb.cn/h.fmmXNuA?sm=4490cf')
      } else {
        // alert('pc端')
        window.open(
          'https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.1.41467688U5jPSb&id=657498357938&skuId=4920795167805&user_id=2210522335310&cat_id=2&is_b=1&rn=e796c282b02cff6b9053ae25f07ec402'
        )
      }
    },
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    }
  }
}
</script>
<style lang="scss" scoped>
.br375 {
    display: none;
}
.riff {
    overflow: auto;
    background: #fff;
    & > div {
        margin: 0 auto;
    }
}
.riff_bg {
    background: url("../assets/riff/BG.png") no-repeat;
    background-size: 100% 100%;
    height: 640px;
    position: relative;
    display: flex;
    justify-content: center;
    .riff_icon_box {
        width: 100%;
        height: 640px;
        display: flex;
        align-items: center;
        justify-content: center;
        .riff_icon {
            width: 1080px;
            height: 324.71px;
        }
        .riff_icon1 {
            display: none;
        }
    }
}
//第二层
.goods_msg {
    height: 648px;
    background: #fff;
    position: relative;
    .msg {
        height: 648px;
        display: flex;
        justify-content: center;
        padding-top: 79px;
        .left {
            width: 465px;
            height: 237px;
            margin-right: 453px;
            background: #fff;
        }
        .right {
            width: 355px;
            height: 176px;
            background: #fff;
        }
        .right_text {
            min-width: 355px;
            .title {
                margin-bottom: 12px;
                display: flex;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 24px;
                line-height: 28px;
                color: #000000;
            }
            .title :nth-child(1) {
                padding-right: 8px;
                border-right: 1px solid #000000;
            }
            .title :nth-child(2) {
                padding-left: 12px;
            }
            .rule {
                margin-bottom: 12px;
                font-family: Roboto;
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                line-height: 22px;
                color: #181920;
            }
            .round {
                margin-bottom: 12px;
                display: flex;
                div {
                    margin-right: 12px;
                    width: 40px;
                    height: 40px;
                    left: 0px;
                    top: 74px;
                    border-radius: 50%;
                    background: #000000;
                }
                div:nth-child(2) {
                    background: #c61f33;
                }
                div:nth-child(3) {
                    background: #3fa27a;
                }
                div:nth-child(4) {
                    background: #1e5595;
                }
            }
            .button {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 200px;
                height: 50px;
                border-radius: 50px;
                background: #e02020;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 26px;
                line-height: 22px;
                color: #fff;
                position: relative;
                z-index: 3;
            }
        }
    }
    .icon_box {
        position: absolute;
        top: -157px;
        width: 100%;
        height: 648px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        .riff_icon {
            margin-left: 30px;
            // position: absolute;
            width: 300px;
            height: 462.73px;
            z-index: 2;
        }
        .line {
            position: absolute;
            width: 2560px;
            height: 506px;
            top: 300px;
            z-index: 1;
            width: 2560px;
            height: 506px;
            background: url("../assets/riff/line.png") no-repeat;
        }
    }
}
// 第三层
.three {
    width: 100%;
    height: 1024px;
    display: flex;
    justify-content: center;
    background: #fff;
    .left {
        // width: 50%;
        display: flex;
        justify-content: flex-end;
    }
    .left_text {
        padding-top: 93px;
        margin-right: 95px;
        width: 522px;
        .title {
            font-family: Roboto;
            font-style: normal;
            font-weight: 900;
            font-size: 72px;
            line-height: 110%;
            color: #000000;
            margin-bottom: 70px;
        }
        .content {
            font-family: Roboto;
            font-style: normal;
            font-weight: 500;
            font-size: 36px;
            line-height: 150%;
            color: #000000;
        }
    }
    .right_img {
        width: 1280px;
        background: url("../assets/riff/three_bg.png") no-repeat;
        background-size: 1280px 1024px;
        padding-top: 93px;
        padding-left: 103px;
        box-sizing: border-box;
        img {
            width: 613px;
            height: 467px;
        }
    }
}
// 第四层
.four {
    height: 1023px;
    display: flex;
    justify-content: center;
    position: relative;
    div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 1023px;
        width: 2560px;
        background: url("../assets/riff/four_img.png") no-repeat;
        background-size: 2560px 1023px;
    }
}
// 第五层
.five {
    height: 360px;
    display: flex;
    justify-content: center;
    position: relative;
    div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 360px;
        width: 2560px;
        background: url("../assets/riff/four_img2.png") no-repeat;
        background-size: 2560px 360px;
    }
}
// 第六层
.six {
    max-width: 2560px;
    height: 1280px;
    background: #000000;
    display: flex;
    justify-content: flex-end;
    overflow: hidden;
    .box {
        width: 2000px;
        height: 1280px;
        background: url("../assets/riff/six_bg1.png") no-repeat;
        background-size: 2000px 1280px;
        position: relative;
        padding-top: 275px;
        padding-left: 317px;
        .img_icon {
            position: absolute;
            top: 105px;
            left: -201px;
            width: 1195px;
            height: 1195px;
        }
        .img_icon2 {
            display: none;
        }
        .text {
            // width: 1684px;
            height: 540px;
            background: url("../assets/riff/six_bg2.png") no-repeat;
            background-size: 1684px 540px;

            .title {
                padding-top: 97px;
                padding-left: 413px;
                font-family: Roboto;
                font-style: normal;
                font-weight: 900;
                font-size: 72px;
                line-height: 100%;
                color: #ffffff;
                .br768 {
                    display: none;
                }
            }
            .text_box {
                padding-top: 63px;
                padding-left: 413px;
                font-family: Roboto;
                font-style: normal;
                font-weight: 600;
                font-size: 36px;
                line-height: 150%;
                color: #ffffff;
                .br768 {
                    display: none;
                }
            }
        }
    }
}
// 第七层
.seven {
    // width: 2560px;
    height: 1280px;
    background: #fff;
    display: flex;
    justify-content: center;
    padding-top: 120px;
    .box {
        width: 1240px;
        height: 960px;
        background: url("../assets/riff/seven_bg2.png") no-repeat;
        background-size: 1240px 960px;
        position: relative;
        padding-top: 140px;
        padding-left: 160px;
        display: flex;
        .seven_bg1 {
            position: absolute;
            bottom: 0;
            left: -139px;
            min-width: 1531.33px;
            min-height: 290.27px;
        }
        .left_text {
            margin-right: 126px;
            p {
                font-family: Roboto;
                font-style: normal;
                font-weight: 900;
                font-size: 72px;
                line-height: 100%;
                color: #000000;
            }
            p:nth-child(1) {
                margin-bottom: 72px;
            }
        }
        .right_text {
            .rule {
                font-family: Roboto;
                font-style: normal;
                font-weight: 500;
                font-size: 36px;
                line-height: 150%;
                color: #000000;
                margin-bottom: 37px;
            }
            .list {
                // width: 428px;
                .one_line {
                    display: flex;
                    margin-bottom: 35px;
                    // justify-content: space-between;
                    div:nth-child(1) {
                        width: 212px;
                        margin-right: 56px;
                    }
                    div {
                        .success {
                            width: 24px;
                            height: 24px;
                        }
                        p {
                            margin: 8px 0;
                            font-family: Roboto;
                            font-style: normal;
                            font-weight: bold;
                            font-size: 24px;
                            line-height: 20px;
                            letter-spacing: 0.1em;
                            text-transform: uppercase;
                            color: #000000;
                        }
                        span {
                            font-family: Roboto;
                            font-style: normal;
                            font-weight: normal;
                            font-size: 18px;
                            line-height: 20px;
                            letter-spacing: 0.01em;
                            color: #959595;
                        }
                    }
                }
            }
        }
    }
}
// 第八层
.eight {
    background: #131415;
    max-width: 2560px;
    height: 1280px;
    display: flex;
    justify-content: center;
    .box {
        width: 100%;
        height: 1280px;
        position: relative;
        padding: 421px 0 0 418px;
        .icon1 {
            position: absolute;
            width: 1335px;
            height: 828px;
            left: 1022px;
            top: 228px;
            z-index: 3;
        }
        .icon1_768 {
            display: none;
        }
        .icon2 {
            position: absolute;
            top: 0;
            left: 571px;
            width: 1091.91px;
            height: 1280px;
            z-index: 1;
        }
        .icon3 {
            position: absolute;
            width: 1684px;
            height: 587px;
            left: 0;
            top: 338px;
        }
        .text {
            position: relative;
            z-index: 4;
            .text1 {
                font-family: Roboto;
                font-style: normal;
                font-weight: 900;
                font-size: 72px;
                line-height: 120%;
                color: #ffffff;
                margin-bottom: 49px;
            }
            .text2 {
                font-family: Roboto;
                font-style: normal;
                font-weight: 600;
                font-size: 36px;
                line-height: 150%;
                color: #ffffff;
            }
        }
    }
}
.nine1-1 {
    display: none;
}
// 第九层
.nine {
    max-width: 2560px;
    height: 1280px;
    background: url("../assets/riff/nine_bg.png") no-repeat;
    background-size: 2560px 1280px;
    position: relative;
    padding-top: 200px;
    display: flex;
    justify-content: center;
    .nine_box {
        width: 784px;
        height: 890px;
        background: url("../assets/riff/nine_img.png") no-repeat;
        background-size: 784px 890px;
        position: relative;
        left: 216px;
        .title {
            padding: 624px 0 0 85px;
            font-family: Roboto;
            font-style: normal;
            font-weight: 900;
            font-size: 72px;
            line-height: 100%;
            color: #ffffff;
        }
        .text {
            padding: 26px 0 0 85px;
            width: 704px;
            font-family: Roboto;
            font-style: normal;
            font-weight: 600;
            font-size: 36px;
            line-height: 150%;
            color: #ffffff;
        }
    }
}
// 第十层
.ten {
    max-width: 2560px;
    height: 1280px;
    display: flex;
    justify-content: center;
    align-items: center;
    .ten_box {
        position: relative;
        left: 123px;
        width: 1484px;
        height: 1280px;
        display: flex;
        .left {
            width: 507px;
            .title {
                margin-top: 206px;
                font-family: Roboto;
                font-style: normal;
                font-weight: 900;
                font-size: 72px;
                line-height: 100%;
                color: #000000;
            }
            .rule {
                margin: 74px 0 61px 0;
                font-family: Roboto;
                font-style: normal;
                font-weight: 500;
                font-size: 36px;
                line-height: 150%;
                color: #000000;
            }
            .list {
                // width: 428px;
                .one_line {
                    display: flex;
                    margin-bottom: 35px;
                    // justify-content: space-between;
                    div:nth-child(1) {
                        width: 212px;
                        margin-right: 56px;
                    }
                    div {
                        .success {
                            width: 24px;
                            height: 24px;
                        }
                        p {
                            margin: 8px 0;
                            font-family: Roboto;
                            font-style: normal;
                            font-weight: bold;
                            font-size: 24px;
                            line-height: 20px;
                            letter-spacing: 0.1em;
                            text-transform: uppercase;
                            color: #000000;
                        }
                        span {
                            font-family: Roboto;
                            font-style: normal;
                            font-weight: normal;
                            font-size: 18px;
                            line-height: 20px;
                            letter-spacing: 0.01em;
                            color: #959595;
                        }
                    }
                }
            }
        }
        .right {
            width: 977px;
            display: flex;
            align-items: flex-end;
            position: relative;
            .img {
                width: 977px;
                height: 991px;
                position: relative;
                z-index: 2;
            }
            .img2 {
                position: absolute;
                left: 329px;
                width: 378px;
                height: 1280px;
            }
        }
    }
}
@media screen and (min-width: 0px) and (max-width: 1254px) {
    .riff {
        width: 100vw;
        overflow: hidden;
    }
    .riff_bg {
        height: 904px;
        .riff_icon_box {
            width: 100%;
            height: 904px;
            display: block;
            text-align: center;
            .riff_icon {
                margin: 119px auto 0 auto;
                max-width: 597px;
                width: 100%;
                height: 178px;
            }
            .riff_icon1 {
                margin: 70px auto 0 auto;
                display: block;
                width: 300px;
                height: 462.73px;
                p {
                    font-family: Roboto;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 24px;
                    line-height: 28px;
                    text-align: center;
                    color: #ffffff;
                }
                img {
                    width: 300px;
                    height: 462.73px;
                }
            }
        }
    }
    //第二层
    .goods_msg {
        height: 400px;
        .msg {
            height: auto;
            .left {
                display: none;
            }
            .right_text {
                text-align: center;
                .title {
                    display: flex;
                    justify-content: center;
                    p {
                        font-weight: bold;
                        font-size: 24px;
                        line-height: 28px;
                    }
                }
                .rule {
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 22px;
                }
                .round {
                    display: flex;
                    justify-content: center;
                    div {
                        width: 33.33px;
                        height: 33.33px;
                    }
                }
                .button {
                    margin: 0 auto;
                    width: 200px;
                    height: 50px;
                    font-weight: bold;
                    font-size: 26px;
                    line-height: 22px;
                }
            }
        }
        .icon_box {
            display: none;
        }
    }
    // 第三层
    .three {
        display: block;
        height: 1210px;
        .left {
            .left_text {
                margin: 0;
                width: 100%;
                padding-top: 54px;
                padding-left: 20px;
                p:nth-child(1) {
                    font-weight: 900;
                    font-size: 48px;
                    margin-bottom: 76px;
                }
                p:nth-child(2) {
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 150%;
                    margin-bottom: 105px;
                }
            }
        }
        .right_img {
            height: 907px;
            min-width: 100%;
            padding: 0;
            padding: 83px 0 0 95px;
            background-size: 100% 907px;
            img {
                width: 542px;
                height: 413px;
            }
        }
    }
    // 第四层
    .four {
        height: 480px;

        div {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 1196px;
            height: 480px;
            background: url("../assets/riff/four_img.png") no-repeat;
            background-size: 1196px 480px;
        }
    }
    // 第五层
    .five {
        height: 219px;
        display: flex;
        div {
            position: absolute;
            top: 0%;
            left: 50%;
            transform: translate(-50%, 0%);
            width: 1142px;
            height: 171px;
            background: url("../assets/riff/four_img2.png") no-repeat;
            background-size: 1142px 171px;
        }
    }
    // 第六层
    .six {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 1006px;
        .box {
            background: none;
            padding: 0;
            padding: 78px;
            width: auto;
            height: 1006px;
            .img_icon {
                display: none;
            }
            .img_icon2 {
                display: inline-block;
                width: 579px;
                height: 508px;
            }
            .text {
                background: none;
                width: 474px;
                height: 391px;
                text-align: center;
                margin: 0 auto;
                .title {
                    font-weight: 900;
                    font-size: 48px;
                    line-height: 120%;
                    text-align: center;
                    padding: 0;
                    .br768 {
                        display: block;
                    }
                }
                .text_box {
                    margin-top: 48px;
                    padding: 0;
                    font-weight: 600;
                    font-size: 24px;
                    line-height: 150%;
                    span {
                        display: inline-block;
                        width: 135px;
                        text-align: left;
                    }
                    .br768 {
                        display: block;
                    }
                }
            }
        }
    }
    // 第七层
    .seven {
        height: 1067px;
        padding: 0;
        .box {
            padding: 64px 20px 0 20px;
            height: 1067px;
            background-size: 1240px 1067px;
            display: block;
            .seven_bg1 {
                position: absolute;
                bottom: 37px;
                left: 20px;
                min-width: 1149.33px;
                min-height: 217.86px;
            }
            .left_text {
                margin-right: 0px;
                margin-bottom: 35px;
                p {
                    font-weight: 900;
                    font-size: 48px;
                    line-height: 130%;
                }
                p:nth-child(1) {
                    margin-bottom: 0px;
                }
            }
            .right_text {
                .rule {
                    margin-bottom: 48px;
                    font-size: 24px;
                    line-height: 150%;
                }
                .list {
                    .one_line {
                        div:nth-child(1) {
                        }
                        div {
                            .success {
                            }
                            p {
                                font-weight: bold;
                                font-size: 20px;
                                line-height: 20px;
                            }
                            span {
                                font-size: 16px;
                                line-height: 20px;
                                letter-spacing: 0.01em;
                            }
                        }
                    }
                }
            }
        }
    }
    // 第八层
    .eight {
        height: 935px;
        .box {
            padding: 0;
            height: 935px;
            .icon1 {
                display: none;
            }
            .icon1_768 {
                margin: 0 auto;

                display: block;
                position: relative;
                left: 0;
                top: 0;
                width: 444px;
                height: 275px;
            }
            .icon2 {
                display: none;
            }
            .icon3 {
                display: none;
            }
            .text {
                margin: 72px auto 0 auto;

                width: 470px;
                height: 483px;
                text-align: center;
                .text1 {
                    font-weight: 900;
                    font-size: 48px;
                    line-height: 120%;
                }
                .text2 {
                    margin-top: 24px;
                    font-weight: 600;
                    font-size: 24px;
                    line-height: 150%;
                }
            }
        }
    }
    .nine1-1 {
        display: block;
        height: 353px;
        background: url("../assets/riff/nine_bg.png") no-repeat;
        background-size: 100% 392px;
    }
    // 第九层
    .nine {
        background: none;
        // width: 768px;
        height: 870px;
        padding: 0;
        justify-content: flex-start;
        .nine_box {
            min-width: 768px;
            height: 870px;
            background-size: 100% 870px;
            left: 0;
            .title {
                padding: 0;
                font-weight: 900;
                font-size: 48px;
                line-height: 100%;
                padding-top: 669px;
                padding-left: 21px;
            }
            .text {
                padding: 0;
                width: 100%;
                max-width: 478px;
                font-weight: 600;
                font-size: 24px;
                line-height: 150%;
                padding-top: 24px;
                padding-left: 21px;
            }
        }
    }
    // 第十层
    .ten {
        width: 100%;
        height: auto;

        .ten_box {
            position: relative;
            left: 0px;
            width: 100%;
            display: block;
            height: auto;

            .left {
                margin: 0 auto;
                .title {
                    margin-top: 80px;
                }
                .rule {
                }
                .list {
                    .one_line {
                        div:nth-child(1) {
                        }
                        div {
                            .success {
                            }
                            p {
                            }
                            span {
                            }
                        }
                    }
                }
            }
            .right {
                width: 100%;
                margin: 0 auto;
                .img {
                    position: relative;
                    margin: 0 auto;
                    width: 438px;
                    height: 444px;
                }
                .img2 {
                    display: none;
                }
            }
        }
    }
}
@media screen and (min-width: 0px) and (max-width: 457px) {
    .riff_bg {
        height: 625px;

        .riff_icon_box {
            width: 100%;
            height: 625px;
            .riff_icon {
                margin: 66px auto 0 auto;
                max-width: 315px;
                width: 100%;
                height: 94px;
            }
            .riff_icon1 {
                margin: 49px auto 0 auto;
                display: block;
                width: 300px;
                // height: 462.73px;
                p {
                    font-family: Roboto;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 18px;
                    line-height: 28px;
                    text-align: center;
                    color: #ffffff;
                }
                img {
                    margin: 0 auto;
                    width: 264.55px;
                    height: 365.27px;
                }
            }
        }
    }
    //第二层
    .goods_msg {
        .msg {
            padding-top: 93px;
            .left {
            }
            .right_text {
                .title {
                    p {
                    }
                }
                .rule {
                }
                .round {
                    div {
                    }
                }
                .button {
                }
            }
        }
        .icon_box {
            // display: none;
        }
    }
    // 第三层
    .three {
        display: block;
        height: auto;
        .left {
            .left_text {
                margin: 0;
                width: 100%;
                padding-top: 0px;
                padding-left: 15px;
                p:nth-child(1) {
                    font-weight: 900;
                    font-size: 36px;
                    margin-bottom: 24px;
                }
                p:nth-child(2) {
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 150%;
                    margin-bottom: 42px;
                }
            }
        }
        .right_img {
            width: 533.75px;
            height: 359px;
            padding: 0;
            padding: 39px 0 0 45px;
            background: url("../assets/riff/three_bg2.png") no-repeat;
            background-size: 533.75px 359px;
            img {
                display: none;
                width: 255.62px;
                height: 194.74px;
            }
        }
    }
    // 第四层
    .four {
        height: 280px;
        div {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 700px;
            height: 280px;
            background: url("../assets/riff/four_img.png") no-repeat;
            background-size: 700px 280px;
        }
    }
    // 第五层
    .five {
        height: 124px;
        // display: flex;
        div {
            position: absolute;
            top: 0%;
            left: 50%;
            transform: translate(-50%, 0%);
            width: 375px;
            height: 56px;
            background: url("../assets/riff/four_img2.png") no-repeat;
            background-size: 375px 56px;
        }
    }
    // 第六层
    .six {
        height: 964px;
        .box {
            padding: 0;
            padding-top: 61px;
            height: 964px;
            .img_icon {
            }
            .img_icon2 {
                position: absolute;
                bottom: 0px;
                left: 50%;
                transform: translate(-50%, 0);
                min-width: 579px;
                height: 579px;
            }
            .text {
                .title {
                    font-size: 36px;
                    .br768 {
                    }
                    .br375 {
                        display: block;
                    }
                }
                .text_box {
                    margin-top: 70px;
                    font-size: 18px;
                    span {
                        padding-left: 20px;
                    }
                    .br768 {
                    }
                    .br375 {
                        display: block;
                    }
                }
            }
        }
    }
    // 第七层
    .seven {
        height: 1052px;
        // padding: 0;
        .box {
            height: 1052px;
            padding: 67px 15px 0 15px;
            .seven_bg1 {
                bottom: 67px;
                left: -94px;
                width: 1280.33px;
                height: 242.69px;
            }
            .left_text {
                p {
                    font-size: 36px;
                }
                p:nth-child(1) {
                }
            }
            .right_text {
                .rule {
                    font-size: 18px;
                    margin-bottom: 18px;
                }
                .list {
                    .one_line {
                        div:nth-child(1) {
                            margin-right: 14px;
                        }
                        div {
                            width: 165px !important;
                            .success {
                            }
                            p {
                                font-size: 18px;
                            }
                            span {
                                font-size: 14px;
                            }
                        }
                    }
                }
            }
        }
    }
    // 第八层
    .eight {
        height: 1076px;
        .box {
            height: 1076px;

            .icon1 {
            }
            .icon1_768 {
                position: absolute;
                top: 600px;
                left: 50%;
                transform: translate(-50%,0%);
                min-width: 666px;
                min-height: 385.5px;
            }
            .icon2 {
            }
            .icon3 {
            }
            .text {
                width: 100%;
                margin: 127px auto 0 auto;
                height: 430px;
                .text1 {
                    font-size: 36px;
                    margin-bottom: 60;
                    .br375 {
                        display: block;
                    }
                }
                .text2 {
                    font-size: 18px;
                }
            }
        }
    }
    .nine1-1 {
        display: block;
        height: 176px;
        background: url("../assets/riff/nine_bg.png") no-repeat;
        background-size: 100% 176px;
    }
    // 第九层
    .nine {
        .nine_box {
            .title {
                font-size: 40px;
            }
            .text {
                max-width: 343px;
                font-size: 18px;
                padding-top: 19px;
            }
        }
    }
    // 第十层
    .ten {
        // width: 100%;
        // height: auto;
        height: 1066px;
        .ten_box {
            // position: relative;
            // left: 0px;
            // width: 100%;
            // display: block;
            // height: auto;

            .left {
                width: 345px;
                margin: 0 auto;
                .title {
                    margin-top: 86px;
                    font-size: 40px;
                }
                .rule {
                    margin: 32px 0;
                    font-weight: 500;
                    font-size: 18px;
                }
                .list {
                    .one_line {
                        div:nth-child(1) {
                        }
                        div {
                            width: 250px;
                            margin-right: 0;
                            .success {
                            }
                            p {
                                font-weight: bold;
                                font-size: 18px;
                                margin: 8px 0;
                            }
                            span {
                                font-weight: normal;
                                font-size: 14px;
                            }
                        }
                    }
                }
            }
            .right {
                // width: 100%;
                // margin: 0 auto;
                width: 438px;
                height: 444px;
                overflow: hidden;
                position: relative;
                .img {
                    // position: relative;
                    // margin: 0 auto;
                    // width: 438px;
                    // height: 444px;
                }
                .img2 {
                    // display: none;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/riff_interface.vue